import { ListChecks } from 'lucide-react'
import PropTypes from 'prop-types'
import { useState } from 'react'

import { FormModal } from '@components/branded-modal/FormModal'
import { AdasBox, AdasButton, AdasTextField, AdasTypography } from '@components/wrapper-components'
import { BUTTONS_DISPLAY_LABEL, GENERIC_MESSAGES } from '../../../constants'

/** Admin-code confirmation for opting product line items in/out of QBO invoices.
 *  Uses the app's canonical FormModal shell so it stays in sync with the other
 *  form-style modals across the application. */
export const LineItemsOptInModal = ({ open, onClose, onConfirm, failureMessage, onDismissError }) => {
  const [code, setCode] = useState('')

  const handleClose = () => {
    setCode('')
    onClose()
  }

  const handleConfirm = () => {
    onConfirm(code)
    setCode('')
  }

  const footer = (
    <AdasBox className='flex justify-end gap-2'>
      <AdasButton variant='outlined' onClick={handleClose}>
        {BUTTONS_DISPLAY_LABEL.CANCEL}
      </AdasButton>
      <AdasButton variant='contained' disabled={!code} onClick={handleConfirm}>
        {BUTTONS_DISPLAY_LABEL.CONFIRM}
      </AdasButton>
    </AdasBox>
  )

  return (
    <FormModal
      open={open}
      onClose={handleClose}
      icon={ListChecks}
      eyebrow='QuickBooks Online'
      title={GENERIC_MESSAGES.OPT_IN_LINE_ITEMS_TITLE}
      footer={footer}
      width='max-w-[530px]'
      errorMessage={failureMessage}
      onDismissError={onDismissError}
    >
      <AdasBox className='space-y-4'>
        <AdasBox>
          <AdasTypography component='span' className='font-bold'>
            {'YES = '}
          </AdasTypography>
          <AdasTypography component='span'>{GENERIC_MESSAGES.OPT_IN_LINE_ITEMS_YES_MESSAGE}</AdasTypography>
        </AdasBox>
        <AdasBox>
          <AdasTypography component='span' className='font-bold'>
            {'NO = '}
          </AdasTypography>
          <AdasTypography component='span'>{GENERIC_MESSAGES.OPT_IN_LINE_ITEMS_NO_MESSAGE}</AdasTypography>
        </AdasBox>
        <AdasTypography className='text-[14px] text-muted-foreground'>Enter system admin code to confirm</AdasTypography>
        <AdasTextField
          onChange={(e) => setCode(e.target.value)}
          value={code}
          name='Admin Code'
          id='adminCodeInput'
          label={GENERIC_MESSAGES.SYSTEM_ADMIN_CODE}
          variant='outlined'
          fullWidth
          InputLabelProps={{ shrink: true }}
        />
      </AdasBox>
    </FormModal>
  )
}

LineItemsOptInModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  failureMessage: PropTypes.string,
  onDismissError: PropTypes.func
}
